"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromotionSection = void 0;
const React = __importStar(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const merlin_theme_1 = __importDefault(require("@travelnest/merlin.theme"));
const accordion_1 = require("../../../components/accordion");
const booking_svg_1 = __importDefault(require("../../../../92b3b47/assets/images/channels/booking.svg"));
const airbnb_svg_1 = __importDefault(require("../../../../92b3b47/assets/images/channels/airbnb.svg"));
const expedia_svg_1 = __importDefault(require("../../../../92b3b47/assets/images/channels/expedia.svg"));
const vrbo_svg_1 = __importDefault(require("../../../../92b3b47/assets/images/channels/vrbo.svg"));
const PromotionItem_1 = require("./PromotionItem");
const ImageWrap = styled_1.default.span `
	margin-right: 10px;
	width: 40px;
	height: 40px;
	background-color: ${merlin_theme_1.default.palette.blue.primary};
	border-radius: 50%;
`;
const Image = styled_1.default.img `
	width: 40px;
	height: 40px;
`;
const icons = {
    'booking.com': booking_svg_1.default,
    'airbnb.com': airbnb_svg_1.default,
    'homeaway.co.uk': vrbo_svg_1.default,
    'expedia.com': expedia_svg_1.default,
};
const getPromotionsSelected = (promotions) => {
    const count = promotions.filter(p => p.selected).length;
    return `${count} ${count === 1 ? 'promotion' : 'promotions'} selected`;
};
const PromotionSection = ({ id, title, promotions, onCheckboxClick, }) => {
    return (React.createElement(accordion_1.Accordion, { key: `accordion-${id}` },
        React.createElement(accordion_1.AccordionHeader, { icon: () => React.createElement(ImageWrap, null,
                React.createElement(Image, { src: icons[id] })) },
            React.createElement(accordion_1.DefaultAccordionHeading, { heading: title, subheading: getPromotionsSelected(promotions) })),
        React.createElement(accordion_1.AccordionItem, { noBorder: true }, promotions.map((p) => (React.createElement(PromotionItem_1.PromotionItem, { promotion: p, onCheckboxClick: onCheckboxClick }))))));
};
exports.PromotionSection = PromotionSection;
//# sourceMappingURL=PromotionSection.js.map